import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_PARAMS } from '../../../utils/constants';

export default (paramsVar) => {
  return (newParams) => {
    paramsVar(newParams);
    setSessionStorageItem(SESSION_STORAGE_LAST_PARAMS, newParams);
  };
};
